export default "__VITE_ASSET__fv8Y5GCz__"